import image_logo from "./assets/logo/Logo_NoBackground_red2.png";

export default {
  pages: {
    root: {
      name: "root",
      children: ["66c7c2dc2fc7070018bb3076", "66c7c2dc2fc7070018bb307a"],
      id: "root",
      pageUrl: "root",
    },
    "66c7c2dc2fc7070018bb3076": {
      id: "66c7c2dc2fc7070018bb3076",
      name: "404",
      pageUrl: "404",
    },
    "66c7c2dc2fc7070018bb307a": {
      id: "66c7c2dc2fc7070018bb307a",
      name: "index",
      pageUrl: "index",
    },
  },
  mode: "production",
  projectType: "create-react-app",
  site: {
    styles: {
      background: "--color-dark",
      font: "16px --fontFamily-googleRubik",
    },
    seo: {
      background_win10: "#232323",
      title: "RED Club @UAlberta",
      description:
        "Building renewable systems, exploring sustainability concepts, socializing with new friends.",
      "og:title": "RED Club @UAlberta",
      "og:description":
        "Building renewable systems, exploring sustainability concepts, socializing with new friends.",
      favicon_apple_152px: image_logo,
      favicon_win10_270px: image_logo,
      "og:image": image_logo,
      favicon_32px: image_logo,
      robotsFileType: "autogenerated",
      sitemapFileType: "autogenerated",
    },
  },
};
